import type { ChartSettings } from "@/classes/BaseChart";
import DecompositionLineMerger from "@/classes/lineMetricMerge/DecompositionLineMerger";
import LineMetricMerger from "@/classes/lineMetricMerge/LineMetricMerger";
import TopNAxisLineMerger from "@/classes/lineMetricMerge/TopNAxisLineMerger";
import TopNDecompositionLineMerger from "@/classes/lineMetricMerge/TopNDecompositionLineMerger";

const MERGERS: Record<string, new (settings: ChartSettings) => LineMetricMerger> = {
  stackedColumnLineDecompositionTimeChart: DecompositionLineMerger,
  stackedColumnLineDecompositionChart: TopNDecompositionLineMerger,
  stackedColumnLineChart: TopNAxisLineMerger,
};

export const getLineMetricMerger = (chartName: string, settings: ChartSettings): LineMetricMerger | null => {
  const Merger = MERGERS[chartName];

  return Merger ? new Merger(settings) : null;
};

export default LineMetricMerger;
